import { useState, useEffect } from 'react'
import PublicAppHeader from '../PublicAppHeader'
import { getFeatureList } from 'src/consumer/services/featureServices'
import { LoadingSpinner } from '../Loaders'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { PublicListingComponentVarOne } from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { getListItemsFromJournalsList } from '../ListingPageComponentsAndHelpers/ListingPageHelpers'

export default function JournalsListingPage() {
  const [pageLoading, setPageLoading] = useState(false)
  const [journalsList, setJournalsList] = useState()

  const [pageNumber, setPageNumber] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(true)

  async function pageSetup() {
    setPageLoading(true)
    const resp = await getFeatureList('journal')
    if (resp?.status === 200) {
      setJournalsList(resp?.data)
    }
    setPageLoading(false)
  }

  async function getNextJournalsPage() {
    const nextPageNumber = pageNumber + 1

    const resp = await getFeatureList('journal', nextPageNumber)

    if (resp?.status === 200) {
      if (resp?.data && resp?.data?.length > 0) {
        setPageNumber(nextPageNumber)
        setJournalsList((prev) => [...prev, ...resp?.data])
      } else {
        // If there's no more data to load, set hasNextPage to false
        setHasNextPage(false)
      }
    } else {
      setHasNextPage(false)
    }
  }

  const [sentryRef] = useInfiniteScroll({
    hasNextPage,
    onLoadMore: getNextJournalsPage,
    rootMargin: '0px 0px 20px 0px',
  })

  useEffect(() => {
    pageSetup()
  }, [])

  return (
    <>
      <SEOComponent
        title="Discover the Power of Journaling | AUMHUM"
        description="Clear your mind with guided journaling at AUMHUM, fostering mental clarity and personal reflection."
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['journal', 'personal', 'discovery']}
      />
      {pageLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <PublicAppHeader config={{ showLinks: true }} />
          <PublicListingComponentVarOne
            heading="Discover the Power of Journaling"
            description="Write your thoughts and feelings in a safe space."
            actionText="Start journal"
            listItemsArray={getListItemsFromJournalsList(journalsList)}
            sentryRef={sentryRef}
            hasNextPage={hasNextPage}
          />
        </>
      )}
    </>
  )
}
